export default __webpack_public_path__ + "img/logo_instagram.9cf859.svg";